<template>
    <section class="a-report-block">
        <div class="a-report-block__wrapper">
            <h3 class="a-report-block__title">
                {{ reportData.title }}
            </h3>
            <p class="a-report-block__desc">
                {{ reportData.desc }}
            </p>
        </div>
        <div class="a-report-block__wrapper">
            <div class="a-report-block__select">
                <select-date-filter
                    @option-selected="optionSelected"
                    @date-selected="dateSelected" />
            </div>
            <div
                v-if="list.data.length !== 0"
                class="a-report-block__table">
                <div
                    class="a-report-block__item"
                    v-for="item in list.data.slice(0, 5)"
                    :key="item.id">
                    <div class="a-report-block__col a-report-block__col-title">
                        {{ item.props.period }}
                    </div>
                    <div
                        class="a-report-block__col a-report-block__btn-wrap"
                        :class= "{ 'hasPress': item.props.href_press_release, 'hasApp': item.props.file2 }">
                        <a
                            v-if="item.props.file2"
                            class="a-report-block__download"
                            :href="item.props.file2.src"
                            :title="item.props.file2.name"
                            :download="item.props.file2.name">
                            <svg
                                width="10"
                                height="19"
                                viewBox="0 0 10 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M5.5 0L5.5 9H10L5 15L0 9H4.5L4.5 0H5.5ZM10 18.5V17.5H0V18.5H10Z"
                                    fill="#8BC540"></path>
                            </svg>
                            Приложение
                        </a>
                        <a
                            class="a-report-block__link a-arrow-icon"
                            :href="item.props.link_to_report ? item.props.link_to_report : item.props.file.src"
                            :title="item.props.link_to_report ? 'Читать отчет' : item.props.file.name"
                            target="_blank">
                            Читать отчет

                        </a>
                        <a
                            v-if="item.props.href_press_release"
                            class="a-report-block__link a-arrow-icon a-report-block__link--press"
                            :href="item.props.href_press_release"
                            :title="item.props.title">
                            Пресс-релиз
                        </a>
                    </div>
                </div>
            </div>
            <empty-text
                v-else
                :empty-text="emptyText" />
            <a
                class="a-report-block__button"
                :href="reportData.button.href"
                :title="reportData.button.text">
                {{ reportData.button.text }}
            </a>
        </div>
    </section>
</template>

<script>
    import SelectDateFilter from './helpers/SelectDateFilter'
    import EmptyText from './helpers/EmptyText'

    export default {
        name: 'ReportBlock',
        data() {
            return {
                emptyText: 'За данный период ничего не найдено.',
            }
        },
        components: {
            SelectDateFilter,
            EmptyText
        },
        props: {
            reportData: Object,
            list: Object,
            mobileDevice: Boolean
        },
        methods: {
            optionSelected (id) {
                this.$emit('listOptionSelected', id)
            },

            dateSelected (dateStart, dateEnd) {
                this.$emit('listDateSelected', dateStart, dateEnd)
            }
        },
    }
</script>